import { AonDialog } from "../../components/core/AonDialog";
import { UuiFlexlayout, UuiLogo } from "@aonunited/react";
;
import { AonButton } from "../../components/core/AonButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import "./clientStaffDailog.scss";
import { AonLink, LINK_TYPE } from "../../components/core/AonLink";
import React from "react";
export var EmailExportedDailog = function (props) {
    var DailogBody = function () {
        return React.createElement("div", null,
            React.createElement("h3", { style: { marginTop: "0px", marginBottom: "8px" } }, "Report Submitted"),
            React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                React.createElement("p", null,
                    "Your request has been submitted. It will be emailed you shortly. If you do not recieve your report please contact \u00A0",
                    React.createElement(AonLink, { type: LINK_TYPE.SMALL, to: 'mailto:AonSupport@aon.com' }, " Aon Support"))),
            React.createElement("div", null,
                React.createElement(AonButton, { disabled: false, style: { marginInline: "10px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: function () {
                        props.onClickClose();
                    } }, "Close")));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDailog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
                React.createElement("div", { className: 'logo_about_dialog' },
                    React.createElement(UuiLogo, { onClick: function () { } })),
                React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(DailogBody, null) })));
};
